import $ from "jquery";
import TabManager from "../customTabComponent/customTabComponent";
import Swiper from 'swiper';
import { Navigation} from 'swiper/modules';

const incomePlanOptions = {
    variables: {
        hideChildEl: false,
        url: window.location.href,
    },
    methods: {
        changeTabTextColor: function(){
            const cardTitle = $('.plan-income__card-title');
            cardTitle.each((index, el) => {
                const words = $(el).text().trim().split(' ');
                const lastWord = words.pop();
                $(el).text(words.join(' ') + ' ');
                $(el).append(`<span class='text-blue-400'>${lastWord}</span>`);
            });
        },
        tabsFunction: function() {
            if($(window).width() < 576){
                const tabManager = new TabManager("plan-income__mobile-tabs");
                tabManager.init();
            }
            const swiperTabs = new TabManager("plan-income__swiper-tabs");
            swiperTabs.init();
        },
        initSwiper: function() {
            if($(window).width() >= 576){
                const swiper = new Swiper('.plan-income-swiper', {
                    modules: [ Navigation],
                    navigation: {
                        nextEl: $('.plan-income__desktop .swiper-navigation-next').get(0),
                        prevEl: $('.plan-income__desktop .swiper-navigation-prev').get(0),
                        disabledClass: 'disabled',
                    },
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    // The slides are the plan tabs (role="tab" inside a tablist):
                    // keep that role and their own names instead of Swiper's
                    // role="group" and "1 / 5" labels (WCAG 1.3.1, 4.1.2).
                    a11y: { slideRole: "tab", slideLabelMessage: null },
                    breakpoints: {
                        576: {
                            slidesPerView: 1.3,
                        },
                        768: {
                            slidesPerView:1.2,
                        },
                        992:{
                            slidesPerView:1.55,
                        },
                        1200: {
                            slidesPerView:2,
                            slidesPerGroup: 2,
                        },
                        1400: {
                            slidesPerView:2.616,
                            slidesPerGroup: 2,
                        },
                        1600: {
                            slidesPerView:3,
                            slidesPerGroup: 3,
                        }
                    }
                });
                const slideCount = swiper.slides.length;
                // The cards are tabs (arrow keys move between them, see TabManager):
                // bring a card that receives keyboard focus into view
                $(swiper.slides).on("focusin", function () {
                    swiper.slideTo(swiper.slides.indexOf(this));
                });

                if (swiper.slides.length > 0) {
                    $(swiper.slides[0]).addClass('active-tab');
                    const firstSlideId = $(swiper.slides[0]).attr('id');
                    $(`.slide__pane[data-id="${firstSlideId}"]`).addClass('active-content');
                }

                if (slideCount <= 2) {
                    $('.swiper-navigation-next, .swiper-navigation-prev').addClass('d-none');
                } else {
                    $('.swiper-navigation-next, .swiper-navigation-prev').removeClass('d-none');
                    $('.swiper-navigation-next, .swiper-navigation-prev').addClass('d-md-flex');
                }
            }
        },
        showChildElement: function(){
            if(incomePlanOptions.variables.hideChildEl == false){
                $('.slide__content').removeClass('d-none');
            }

            $('.plan-income__main .slide__navigations--item').each((index, el) => {
                $(el).on('click', () => {
                    if(incomePlanOptions.variables.hideChildEl == true){
                        $('.slide__content').removeClass('d-none').show(500);
                        incomePlanOptions.variables.hideChildEl = false;
                    }
                });
            });
        },
        changeActiveTab: function(){
            $('.plan-income__main .tab__navigations--item').each((index, el) => {
                $(el).on('click', () => {
                    if(incomePlanOptions.variables.hideChildEl == false){
                        $('.slide__navigations--item').eq(index).trigger('click');
                    }
                });
            });
        },
        init: function() {
            incomePlanOptions.methods.tabsFunction();
            incomePlanOptions.methods.initSwiper();
            incomePlanOptions.methods.changeTabTextColor();
            incomePlanOptions.methods.showChildElement();
            incomePlanOptions.methods.changeActiveTab();
        },
        knowMoreClickHandler : function () {
                     $(".plan-income__card .chli_btn--outline").on('click', function(){
                        let title = $(this).closest('.plan-income').find('.heading-2').first().text().replace(/\s+/g, ' ').trim();
                        let buttonText = $(this).text().replace(/\s+/g, ' ').trim();
                        let productName = $(this).parent().find(".plan-income__card-title")[0].textContent.replace(/\s+/g, ' ').trim();
                        let obj = incomePlanOptions.methods.dataLayerObj(title,buttonText, productName);
                        createDataLayer('buttonClick', obj);
                     });
                    $('.plan-income .plan-income__main .swiper-navigation-prev').on('click', function(e) {
                        let title = $(this).closest('.plan-income').find('.heading-2').first().text().replace(/\s+/g, ' ').trim();
                        let  buttonText="Previous";
                        var obj = incomePlanOptions.methods.dataLayerObj(title,buttonText,null);
                        createDataLayer('List_Scroll_Previous', obj);
                    });
                    $('.plan-income .plan-income__main .swiper-navigation-next').on('click', function(e) {
                        let title = $(this).closest('.plan-income').find('.heading-2').first().text().replace(/\s+/g, ' ').trim();
                        let  buttonText="Next";
                        var obj = incomePlanOptions.methods.dataLayerObj(title,buttonText,null);
                        createDataLayer('List_Scroll_Next', obj);
                    });
                    },
        dataLayerObj : function(el,e, productName) {
                            var obj = {
                                'articleName' : "",
                                'blogCategory' : "",
                                'blogPageCategory' : "",
                                'buttonText' : e ? e : "",
                                'pageSection' : el ? el : "",
                                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                                'planOption' : "",
                                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                                'question' : "",
                                'searchTerm' : "",
                                'videoTitle' : "",
                                'bannerName' : "",
                                'bannerType' : "",
                                'planOption' : productName ? productName : ""

                            };
                            return obj;
                        },
        }
};

if($('.plan-income').length){
    incomePlanOptions.methods.init();
    incomePlanOptions.methods.knowMoreClickHandler();
}
